import TeacherDashboardSidebarModule from './containers/teacherDashboardSidebarModule'

export {default as TeacherDashboardSidebarModuleLayout} from './components/teacherDashboardSidebarModuleLayout'

export default TeacherDashboardSidebarModule
